// Helpers de tipo de conta financeira (Conta Azul), compartilhados entre as telas
// de Fluxo de caixa e Dashboard Diretoria — fonte única do que é "conta interna".
//
// Contas INTERNAS = movimentos não-operacionais que poluem o saldo de caixa:
// aplicações financeiras, cartão de crédito e a categoria genérica "Outros".
// Podem ser ocultadas do saldo por um toggle (ligado por padrão).

export const TIPO_INTERNO = new Set(['OUTROS', 'APLICACAO', 'CARTAO_CREDITO']);

export const TIPO_LABEL: Record<string, string> = {
  CONTA_CORRENTE: 'Conta corrente',
  CARTAO_CREDITO: 'Cartão de crédito',
  APLICACAO: 'Aplicação',
  OUTROS: 'Outros',
};

/** Normaliza o tipo: sem acento, maiúsculo, sem espaços nas pontas. */
export const normTipo = (tipo: string | null) =>
  (tipo ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().trim();

export const isContaInterna = (tipo: string | null) => TIPO_INTERNO.has(normTipo(tipo));

export const tipoLabel = (tipo: string | null) => TIPO_LABEL[normTipo(tipo)] ?? tipo ?? '';
